import Dialog from "../1. Core/Controls/Dialog/Dialog";
import Select from "../1. Core/Controls/Select/Select";
import {Card, CardStatus, UserCard} from "./types";
import NumField from "../1. Core/Controls/TextField/NumField";
import {ServerAPI} from "../1. Core/ServerAPI";
import NP from "../1. Core/NP";
import IconSelect from "../1. Core/Controls/Select/IconSelect";
import {getCountries, getTournaments, ITournament} from "../10. Battle/Util";
import {IState} from "../2. Athletes/StatesList";
import {SportType} from "../10. Battle/types";


export default class EditUserCardDialog extends Dialog {


	private _Card: UserCard;
	private _cardSelect: Select;
	private _statusCoef: NumField;
	private _statusSelect: Select;
	private _UserId: number;
	private _allCards: Card[];
	private _tournamentCombo: IconSelect;
	private _countryCombo: Select;

	constructor(props: any)
	{
		super(props);
	}

	_initFields(settings: object)
	{
		this._UserId = null
		this._Card = null;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = 'User card';
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'Save'
		this._AutoDestroy = true;
	}

	_render()
	{
		super._render();


		this._cardSelect = new Select({
			FloatingLabel: 'Card',
			ParentNode: this._contentNode,
			EvItemSelected: () =>
			{
				this.updateCoef()

				let cardType = this._cardSelect.getSelectedItem()?.Content;

				NP.setIsVisible([this._countryCombo, this._tournamentCombo], false)

				switch (cardType)
				{
					case 'Promotion':
						this._tournamentCombo.setIsVisible(true)
						break;
					case 'Country':
						this._countryCombo.setIsVisible(true)
						break;
				}

			}
		});

		this._statusSelect = new Select({
			FloatingLabel: 'Status',
			ParentNode: this._contentNode,
			Items: [
				{Content: 'Gold', Value: CardStatus.gold},
				{Content: 'Silver', Value: CardStatus.silver},
				{Content: 'Bronze', Value: CardStatus.bronze}
			],
			EvItemSelected: () =>
			{
				this.updateCoef()
			}
		});

		this._statusCoef = new NumField({
			FloatingLabel: 'Coef',
			FractionCount: 1,
			ParentNode: this._contentNode,
			Value: 1,
			Min: 1,
			Max: 3
		});


		if (this._Card)
		{
			this._statusSelect.setValue(this._Card.status, false);
			this._statusCoef.setValue(this._Card.statusCoef);
		}
		else
		{
			this._statusSelect.setValue(CardStatus.bronze, false)

			this._tournamentCombo = new IconSelect({
				ParentNode: this._contentNode,
				FloatingLabel: NP.RM.getString('Tournament'),
				EvItemSelected: () =>
				{

				}
			});

			this._countryCombo = new Select({
				ParentNode: this._contentNode,
				FloatingLabel: NP.RM.getString('Country'),
				SelectedIndex: 0,
				Items: [{
					Value: null,
					FontImage: NP.FontImages.geo,
					Content: NP.RM.getString('All')
				}],
			});

			getCountries(true).then((res: IState[]) => {
				let items = res.map(state => ({Value: state.Id, FontImage: NP.FontImages.geo, Content: state.Name}));
				if (this._countryCombo)
					this._countryCombo.setItems(items);
			})

			getTournaments(SportType.MMA).then((res: ITournament[]) =>
			{
				if (this._tournamentCombo)
				{
					let items = res.map(t => ({Value: t.Id, FontImage: NP.FontImages.event, Content: t.Name, Data: t}));
					this._tournamentCombo.addItems(items);
				}
			});

			NP.setIsVisible([this._countryCombo, this._tournamentCombo], false)
		}

		this.refresh()
	}

	updateCoef()
	{
		let id = this._cardSelect.getValue() as number;

		let card = this._allCards.find(c => c.id == id)

		if (card)
		{
			switch (this._statusSelect.getValue())
			{
				case CardStatus.gold:
					this._statusCoef.setValue(card.goldCoef);
					break;
				case CardStatus.silver:
					this._statusCoef.setValue(card.silverCoef);
					break;
				case CardStatus.bronze:
					this._statusCoef.setValue(card.bronzeCoef);
					break;
			}
		}

	}

	async refresh()
	{
		let cards = await ServerAPI.get<Card[]>("/cards/items")

		this._allCards = cards;

		this._cardSelect.setItems(cards.map(c => ({
			Content: c.name,
			Value: c.id
		})))

		if (this._Card)
		{
			this._cardSelect.setValue(this._Card.cardId);
			this._cardSelect.setEnabled(false)
		}
	}


	async _onOkButtonClick()
	{
		if (!this._cardSelect.getValue())
			return;

		let isNewCard = !this._Card




		if (isNewCard)
		{
			let data = null;
			switch (this._cardSelect.getSelectedItem()?.Content)
			{
				case 'Athlete':
					data = null
					break
				case 'Promotion':
					data = this._tournamentCombo.getValue()
					if (!data)
						return
					break;
				case 'Country':
					data = this._countryCombo.getValue()
					if (!data)
						return
					break;
			}

			this._Card = {} as UserCard;
			this._Card.exCardData = data;
		}

		this._Card.status = this._statusSelect.getValue()
		this._Card.statusCoef = this._statusCoef.getValue()
		this._Card.cardId = this._cardSelect.getValue()

		if (this._Card.id)
			await ServerAPI.post(`/cards/updateUserCard`, this._Card);
		else
			await ServerAPI.post(`/cards/addCardToUser/${this._UserId}`, this._Card)


		this.EvOkButtonClick.fire(this);
		this.hide();
	}
}
